import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { GrabLinks } from "./GrabLinks";
export var Grab = /*#__PURE__*/function () {
  function Grab() {
    _classCallCheck(this, Grab);
    this.distance = 100;
    this.links = new GrabLinks();
  }
  _createClass(Grab, [{
    key: "line_linked",
    get: function get() {
      return this.links;
    },
    set: function set(value) {
      this.links = value;
    }
  }, {
    key: "lineLinked",
    get: function get() {
      return this.links;
    },
    set: function set(value) {
      this.links = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a, _b;
      if (data === undefined) {
        return;
      }
      if (data.distance !== undefined) {
        this.distance = data.distance;
      }
      this.links.load((_b = (_a = data.links) !== null && _a !== void 0 ? _a : data.lineLinked) !== null && _b !== void 0 ? _b : data.line_linked);
    }
  }]);
  return Grab;
}();